import React from 'react';
import './colors.css';

const NavigationButtons = ({ moveUser, BOTTOM_TAB_HEIGHT }) => {
  return (
    <>
      <button onClick={() => moveUser('up')} className="navigation-button" style={{ top: '10%', left: '50%', transform: 'translate(-50%, -50%) rotate(270deg)' }} />
      <button onClick={() => moveUser('down')} className="navigation-button" style={{ bottom: `calc(${BOTTOM_TAB_HEIGHT}px + 70px)`, left: '50%', transform: 'translate(-50%, 50%) rotate(90deg)' }} />
      <button onClick={() => moveUser('left')} className="navigation-button" style={{ top: '50%', left: '10%', transform: 'translate(-50%, -50%) rotate(180deg)' }} />
      <button onClick={() => moveUser('right')} className="navigation-button" style={{ top: '50%', right: '10%', transform: 'translate(50%, -50%)' }} />
    </>
  );
};

export default NavigationButtons;